import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Spalogy',
    description: 'Spalogy is a B2B wellness ecosystem and concept creator integrating distribution, consulting and concept creation for spa and wellness operators.',
    url: getOrigin()
}

// In-page anchors used by the header and footer navigation.
export const navLinks = [
    { label: 'About', href: '/#about' },
    { label: 'Services', href: '/#services' },
    { label: 'Brands', href: '/#brands' },
    { label: 'Method', href: '/#method' },
    { label: 'Contact', href: '/#contact' }
]
